<template>
  <div id="encontros">
    <div class="encontros-cabecalho">
      <div class="encontros-titulo-area">
        <h6 style="margin: 0">Encontros</h6>
        <span class="badge-contador" v-if="encontros?.length">
          {{ encontros.length }}
        </span>
      </div>
      <button v-if="podeGerenciarEncontros" class="btn-editar-encontros" @click="editarEncontros">
        <i class="ti ti-edit"></i> Editar Encontros
      </button>
    </div>

    <div v-if="encontros?.length">
      <div id="body-encontros" v-for="encontro in encontros" :key="encontro.encontroId">
        <div class="infos-encontros" :class="{ 'is-expanded': encontroExpandido === encontro.encontroId }">
          <div class="encontro" @click="mostrarDescricao(encontro.encontroId)">
            <div class="encontro-titulo">
              <i class="ti ti-chevron-down encontro-chevron" :class="{
                'is-rotated': encontroExpandido === encontro.encontroId,
              }"></i>
              <span>{{ encontro.titulo }}</span>
            </div>

            <div class="encontro-lado-direito">
              <div class="encontro-status-badge" :class="encontro.status?.toLowerCase()">
                <span v-if="encontro.status === 'PROGRAMADO'">
                  <i class="ti ti-calendar-time"></i>
                  {{ formatarData(encontro.inicio_periodo) }} às
                  {{ formatarDataHora(encontro.inicio_periodo).split(" ")[1] }}
                </span>
                <span v-else-if="encontro.status === 'EM_EXECUCAO'">
                  <i class="ti ti-player-play"></i>
                  Em andamento -
                  {{ formatarDataHora(encontro.inicio_periodo).split(" ")[1] }}
                  às
                  {{ formatarDataHora(encontro.fim_periodo).split(" ")[1] }}
                </span>
                <span v-else-if="encontro.status === 'FINALIZADO'">
                  <i class="ti ti-circle-check"></i>
                  Concluído em {{ formatarData(encontro.fim_periodo) }}
                </span>
                <span v-else-if="encontro.status === 'CANCELADO'">
                  <i class="ti ti-circle-x"></i>
                  Cancelado
                </span>
                <span v-else-if="encontro.status === 'INSCRICOES_ABERTAS'">
                  <i class="ti ti-ticket"></i>
                  Inscrições abertas
                </span>
                <span v-else>
                  {{ encontro.status }}
                </span>
              </div>
            </div>
          </div>

          <transition name="accordion">
            <div v-if="encontroExpandido === encontro.encontroId" class="descricao-encontros">
              <div class="descricao-texto">
                <strong>Descrição:</strong>
                <span>{{
                  encontro.descricao ||
                  "Nenhuma descrição informada para este encontro."
                }}</span>
              </div>

              <!-- Galeria de fotos do encontro -->
              <div v-if="
                !isLoadingImagens && imagens.length > 0
              " class="encontro-fotos-preview-strip">
                <div class="fotos-strip-header">
                  <span class="fotos-strip-titulo">
                    <i class="ti ti-photo"></i> Fotos do Encontro
                    <span class="badge-total-strip">({{ totalElementos }})</span>
                  </span>
                  <button type="button" class="btn-ver-todas-fotos" @click.stop="abrirModalFotos(encontro)">
                    Ver todas {{ coordenador ? "e gerenciar" : "" }}<i class="ti ti-arrow-right"></i>
                  </button>
                </div>

                <GaleriaFotosGrid
                  :itens="imagens"
                  :resolver-url="resolverUrlFoto"
                  :obter-alt="(foto) => foto.descricao || 'Foto do encontro'"
                  @abrir="abrirLightbox"
                />
              </div>

              <div class="encontro-acoes">
                <button v-if="props.coordenador" type="button" class="btn-fotos-encontro-acao"
                  @click.stop="abrirModalFotos(encontro)">
                  <i class="ti ti-photo-plus"></i> Fotos do Encontro
                  <span v-if="totalElementos > 0" class="badge-qtd-fotos-btn">
                    {{ totalElementos }}
                  </span>
                </button>
                <button v-if="
                  coordenador &&
                  (viaAcao || dadosAtividade?.acaoExtensaoId || dadosAtividade?.acaoId) &&
                  encontro.status === 'EM_EXECUCAO'
                " class="btn-concluir-encontro" @click.stop="concluirEncontro(encontro.encontroId)">
                  <i class="ti ti-check"></i> Concluir Encontro
                </button>
                <button v-if="
                  coordenador &&
                  (viaAcao || dadosAtividade?.acaoExtensaoId || dadosAtividade?.acaoId) &&
                  podeVerInscritos &&
                  encontro.status !== 'CANCELADO' &&
                  dadosAtividade.modalidadeInscricao ===
                  'NESCESSITA_INSCRICAO' &&
                  isPeriodoInscricaoEncerrado
                " class="btn-baixar-lista" @click.stop="baixarListaAssinatura(encontro.encontroId)">
                  <i class="ti ti-download"></i> Baixar Lista
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div v-else class="encontros-vazio">
      <i class="ti ti-calendar-off"></i>
      <p>Nenhum encontro encontrado.</p>
    </div>

    <button v-if="podeGerenciarEncontros" type="button" class="btn-adicionar-encontro" title="Adicionar novo encontro"
      @click="adicionarEncontro">
      <i class="ti ti-plus"></i> Adicionar encontro
    </button>

    <GaleriaLightbox
      :foto="fotoLightbox"
      :resolver-url="resolverUrlFoto"
      :obter-data="(f) => (f?.dataCriacao || f?.criadoEm || f?.createdAt ? formatarDataHora(f.dataCriacao || f.criadoEm || f.createdAt) : '')"
      :pode-alterar-visibilidade="coordenador"
      :alterando-visibilidade="alterandoVisibilidade"
      :pode-remover="coordenador"
      @fechar="fecharLightbox"
      @remover="removerDoLightbox"
      @alterar-visibilidade="alterarVisibilidadeLightbox"
    />
  </div>
</template>

<script setup>
import GaleriaFotosGrid from '@/components/common/GaleriaFotosGrid.vue';
import GaleriaLightbox from '@/components/common/GaleriaLightbox.vue';
import { useEncontroImagem } from '@/composables/useEncontroImagem';
import { useEncontros } from '@/composables/useEncontros';
import { useToast } from '@/composables/useToast';
import encontrosService from '@/service/encontrosService';
import frequenciaService from '@/service/frequenciaService';
import participantesAtividadeService from '@/service/participantesAtividadeService';
import { formatarData, formatarDataHora } from '@/utils/FormatarEntradas';
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const toast = useToast();
const emits = defineEmits(["abrir-modal-fotos", "atualizar-encontros"]);
const props = defineProps({
  coordenador: {
    type: Boolean,
    default: false,
  },
  dadosAtividade: {
    type: Object,
    default: () => ({}),
  },
  viaAcao: {
    type: Boolean,
    default: false,
  },
  podeVerInscritos: {
    type: Boolean,
    default: false,
  },
  isPeriodoInscricaoEncerrado: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => props.coordenador,
  (novoValor) => {
    console.log("Props coordenador atualizado em EncontrosListagemAtividade:", novoValor);
  },
  { immediate: true }
);

const { encontros, isLoading: isLoadingEncontros, fetchEncontros } = useEncontros();
const {
  imagens,
  isLoading: isLoadingImagens,
  pagination,
  fetchImagensByEncontro,
  deleteImagem,
  modificarVisibilidadeImagem,
} = useEncontroImagem();

const encontroExpandido = ref(null);
const fotoLightbox = ref(null);
const alterandoVisibilidade = ref(false);

const totalElementos = computed(
  () => pagination.totalElements.value || imagens.value.length
);

const podeGerenciarEncontros = computed(
  () =>
    props.coordenador &&
    (props.viaAcao ||
      props.dadosAtividade?.acaoExtensaoId ||
      props.dadosAtividade?.acaoId) &&
    !["CANCELADA", "ENCERRADA", "FINALIZADO", "CONCLUIDA"].includes(
      props.dadosAtividade?.status
    )
);

function resolverUrlFoto(foto) {
  if (!foto) return "";
  if (foto.imagemUrl) return foto.imagemUrl;
  if (foto.url) return foto.url;
  if (foto.imagem?.url) return foto.imagem.url;
  if (foto.imagem?.base64Data) {
    return `data:${foto.imagem.mimeType || "image/jpeg"};base64,${foto.imagem.base64Data}`;
  }
  return "";
}

function abrirLightbox(foto) {
  fotoLightbox.value = foto;
}

function fecharLightbox() {
  fotoLightbox.value = null;
}

async function alterarVisibilidadeLightbox(novaVisibilidade) {
  if (
    !fotoLightbox.value ||
    fotoLightbox.value.isPublica === novaVisibilidade
  ) {
    return;
  }

  alterandoVisibilidade.value = true;
  try {
    await modificarVisibilidadeImagem(
      fotoLightbox.value.id,
      novaVisibilidade
    );
    fotoLightbox.value.isPublica = novaVisibilidade;

    const fotoNaLista = imagens.value.find(
      (f) => f.id === fotoLightbox.value.id
    );
    if (fotoNaLista) {
      fotoNaLista.isPublica = novaVisibilidade;
    }
  } catch (err) {
    console.error("Erro ao alterar visibilidade:", err);
    toast.erro("Não foi possível alterar a visibilidade da foto.");
  } finally {
    alterandoVisibilidade.value = false;
  }
}

async function removerDoLightbox(foto) {
  const fotoId = foto.id;
  const confirmar = window.confirm(
    `Deseja realmente remover esta foto?\n\n"${foto.descricao || "Sem descrição"}"`
  );
  if (!confirmar) return;

  try {
    await deleteImagem(fotoId);
    fecharLightbox();
    if (encontroExpandido.value !== null) {
      await fetchImagensByEncontro(0, 6, encontroExpandido.value, !props.coordenador);
    }
  } catch (err) {
    console.error("Erro ao remover foto:", err);
    toast.erro("Erro ao remover a foto.");
  }
}

function adicionarEncontro() {
  const targetAcaoId =
    route.params.id ||
    props.dadosAtividade?.acaoExtensaoId ||
    props.dadosAtividade?.acaoId;
  const targetAtividadeId =
    route.params.atividadeId || props.dadosAtividade?.id;

  if (targetAcaoId && targetAtividadeId) {
    router.push({
      name: "adicionar-encontros-atividade",
      params: { id: targetAcaoId, atividadeId: targetAtividadeId },
    });
  }
}

function editarEncontros() {
  const targetAcaoId =
    route.params.id ||
    props.dadosAtividade?.acaoExtensaoId ||
    props.dadosAtividade?.acaoId;
  const targetAtividadeId =
    route.params.atividadeId || props.dadosAtividade?.id;

  if (targetAcaoId && targetAtividadeId) {
    router.push({
      name: "editar-encontros-atividade",
      params: { id: targetAcaoId, atividadeId: targetAtividadeId },
    });
  }
}

function mostrarDescricao(id) {
  encontroExpandido.value = encontroExpandido.value === id ? null : id;
}


async function concluirEncontro(encontroId) {
  const atividadeId = props.dadosAtividade?.id || route.params.atividadeId;
  const modalidadeInscricao = props.dadosAtividade?.modalidadeInscricao;
  const verificarPendentesInscritos =
    modalidadeInscricao === "NESCESSITA_INSCRICAO";

  if (verificarPendentesInscritos) {
    try {
      const criterio =
        props.dadosAtividade?.criterioInscricao ||
        props.dadosAtividade?.criterioDeAvaliacaoDeInscricao ||
        "";
      const isCriterioCoordenacao =
        criterio === "CRITERIODACOORDENACAO" ||
        criterio === "CRITERIO_DA_COORDENACAO" ||
        criterio === "Critério da Coordenação";

      const [frequencias, participantesBrutos] = await Promise.all([
        frequenciaService.getFrequencia(encontroId),
        atividadeId
          ? participantesAtividadeService.getParticipantesAtividade(
            0,
            1000,
            atividadeId,
            isCriterioCoordenacao
          )
          : Promise.resolve([]),
      ]);

      const participantes = isCriterioCoordenacao
        ? (participantesBrutos || []).filter(
          (p) =>
            !p.statusInscricao ||
            String(p.statusInscricao).toUpperCase() === "CONFIRMADA"
        )
        : participantesBrutos || [];

      const idsComFrequencia = new Set(
        (frequencias || [])
          .filter(
            (f) => f.statusFrequencia && f.statusFrequencia !== "NAO_LANCADA"
          )
          .map((f) => f.participanteId)
      );

      const pendentes = (participantes || []).filter(
        (p) => !idsComFrequencia.has(p.participanteId)
      );

      if (pendentes.length > 0) {
        const nomes = pendentes
          .map((p) => p.nomeParticipante || p.nome)
          .join("\n  - ");
        const prosseguir = confirm(
          `Atenção! Os seguintes participantes ainda estão com frequência PENDENTE:\n\n  - ${nomes}\n\nDeseja concluir o encontro mesmo assim?`
        );
        if (!prosseguir) return;
      } else {
        const confirmacao = confirm("Deseja realmente concluir este encontro?");
        if (!confirmacao) return;
      }
    } catch (error) {
      console.error("Erro ao verificar frequências pendentes:", error);
      const confirmacao = confirm(
        "Não foi possível verificar as frequências. Deseja concluir o encontro mesmo assim?"
      );
      if (!confirmacao) return;
    }
  } else {
    const confirmacao = confirm("Deseja realmente concluir este encontro?");
    if (!confirmacao) return;
  }

  try {
    await encontrosService.concluirEncontro(encontroId);
    if (atividadeId) {
      await fetchEncontros(0, 1000, atividadeId);
    }
    emits("atualizar-encontros");
    toast.sucesso("Encontro concluído com sucesso!");
  } catch (error) {
    console.error("Erro ao concluir encontro:", error);
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Não foi possível concluir o encontro.";
    toast.erro(msg);
  }
}

async function baixarListaAssinatura(encontroId) {
  try {
    const blob = await encontrosService.downloadListaAssinatura(encontroId);
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `lista_assinatura_${encontroId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao baixar lista de assinatura:", error);
    toast.erro("Não foi possível baixar a lista de assinatura.");
  }
}

watch(encontroExpandido, (value) => {
  if (value !== null) {
    fetchImagensByEncontro(0, 6, value, !props.coordenador);
  }
});

function abrirModalFotos(encontro) {
  emits('abrir-modal-fotos', encontro);
}

onMounted(() => {
  const atividadeId = props.dadosAtividade?.id || route.params.atividadeId;
  if (atividadeId) {
    fetchEncontros(0, 1000, atividadeId);
  }
})
</script>

<style scoped>
#encontros {
  margin-top: 0;
  width: 100%;
}

#body-encontros {
  width: 100%;
  margin-bottom: 10px;
}

.encontros-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.encontros-titulo-area {
  display: flex;
  align-items: center;
  gap: 8px;
}

.encontros-titulo-area h6 {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--roxo-primario);
  margin-bottom: 1rem;
  display: block;
}

.badge-contador {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--roxo-superficie);
  color: var(--roxo-medio);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 99px;
  min-width: 20px;
}

.btn-editar-encontros {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--roxo-medio);
  background-color: var(--roxo-superficie);
  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-editar-encontros:hover {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  transform: translateY(-1px);
}

.btn-adicionar-encontro {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: var(--roxo-medio);
  background-color: transparent;
  border: 2px dashed var(--roxo-medio);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-adicionar-encontro:hover {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  transform: translateY(-1px);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.btn-adicionar-encontro:active {
  transform: translateY(0);
}

.btn-adicionar-encontro:focus-visible {
  outline: 2px solid var(--roxo-primario);
  outline-offset: 2px;
}

.infos-encontros {
  background: var(--branco);
  border: 1.5px solid var(--roxo-superficie);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px -2px hsla(258, 53%, 28%, 0.06);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.infos-encontros:hover {
  border-color: var(--roxo-claro);
  box-shadow: 0 8px 24px -3px hsla(258, 53%, 28%, 0.14);
}

.encontro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: var(--branco);
  cursor: pointer;
  transition: background-color 0.2s ease;
  user-select: none;
  gap: 12px;
}

.encontro:hover {
  background-color: var(--roxo-superficie);
}

.encontro-titulo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--roxo-primario);
}

.encontro-chevron {
  font-size: 1.1rem;
  color: var(--roxo-medio);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.encontro-chevron.is-rotated {
  transform: rotate(180deg);
}

.encontro-lado-direito {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-fotos-encontro-topo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: hsl(258, 50%, 96%);
  color: var(--roxo-claro, #6f319e);
  border: 1.5px solid hsl(258, 45%, 88%);
  padding: 5px 12px;
  border-radius: 99px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-fotos-encontro-topo:hover {
  background-color: hsl(258, 50%, 91%);
  color: var(--roxo-primario, #4a2068);
  border-color: var(--roxo-claro, #6f319e);
  transform: translateY(-1px);
}

.badge-qtd-fotos {
  background-color: var(--roxo-claro, #6f319e);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 99px;
  line-height: 1.2;
}

.encontro-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 99px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.encontro-status-badge span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.encontro-status-badge.programado {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-claro);
}

.encontro-status-badge.em_execucao {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
  border: 1px solid var(--laranja-claro);
}

.encontro-status-badge.finalizado {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
  border: 1px solid var(--verde-claro);
}

.encontro-status-badge.cancelado {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
  border: 1px solid var(--vermelho-claro);
}

.encontro-status-badge.inscricoes_abertas {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  border: 1px solid var(--roxo-superficie);
}

.descricao-encontros {
  background-color: var(--roxo-superficie);
  border-top: 1px dashed var(--roxo-superficie);
  padding: 16px 20px;
  color: var(--roxo-primario);
  font-size: 0.92rem;
  line-height: 1.55;
}

.descricao-texto strong {
  color: var(--roxo-primario);
  margin-right: 6px;
}

/* Faixa de preview no accordion */
.encontro-fotos-preview-strip {
  margin-top: 14px;
  padding: 12px 14px;
  background-color: #ffffff;
  border: 1.5px solid hsl(258, 30%, 91%);
  border-radius: 10px;
}

.fotos-strip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.fotos-strip-titulo {
  font-size: 0.82rem;
  font-weight: 700;
  color: hsl(258, 45%, 25%);
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.badge-total-strip {
  color: hsl(258, 20%, 55%);
  font-weight: 600;
}

.btn-ver-todas-fotos {
  background: none;
  border: none;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--roxo-claro, #6f319e);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  transition: color 0.15s;
}

.btn-ver-todas-fotos:hover {
  color: var(--roxo-primario, #4a2068);
  text-decoration: underline;
}

.encontro-acoes {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-fotos-encontro-acao {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: hsl(258, 45%, 96%);
  color: var(--roxo-claro, #6f319e);
  border: 1.5px solid hsl(258, 40%, 86%);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.btn-fotos-encontro-acao:hover {
  background-color: hsl(258, 50%, 90%);
  border-color: var(--roxo-claro, #6f319e);
  color: var(--roxo-primario, #4a2068);
  transform: translateY(-1px);
}

.badge-qtd-fotos-btn {
  background-color: var(--roxo-claro, #6f319e);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 99px;
}

.btn-concluir-encontro {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: var(--verde);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.08);
}

.btn-concluir-encontro:hover {
  background-color: var(--verde-escuro);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px hsla(135, 45%, 35%, 0.25);
}

.btn-baixar-lista {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.08);
}

.btn-baixar-lista:hover {
  background-color: var(--roxo-escuro);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px hsla(258, 53%, 28%, 0.18);
}

.encontros-vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background-color: var(--branco);
  border: 1.5px dashed var(--roxo-superficie);
  border-radius: 12px;
  color: var(--roxo-medio);
  gap: 8px;
  text-align: center;
}

.encontros-vazio i {
  font-size: 2rem;
  color: var(--roxo-claro);
}

.encontros-vazio p {
  margin: 0;
  font-size: 0.95rem;
}

/* Transição de acordeão suave */
.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 1200px;
  opacity: 1;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
  transform: translateY(-6px);
  overflow: hidden;
}
</style>
